export enum LocalStorageKeys {
  COLORS_THEME = 'colorsTheme',
  FILTERS = 'filters',
  MANAGE_FILTERS_PREFIX = 'manageFilters',
  SELECTED_FILTER_PREFIX = 'selectedFilter',
  FONT_FAMILIES_THEME = 'fontFamiliesTheme',
  FONTS_THEME = 'fontsTheme',
  IMPERSONATION = 'impersonation',
  LOGGED_USER = 'loggedUser',
  LOGO_PATHS = 'logoPaths',
  QUOTE_EXPIRED_COSTING_CANCELED = 'quoteExpiredCostingCanceled',
}
